exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".news-tag[data-v-3a8bbca1]{width:5rem;display:flex;align-items:center;justify-content:center;--bg-opacity:1;background-color:#e6242c;background-color:rgba(230,36,44,var(--bg-opacity));padding:.5rem;font-size:.75rem;--text-opacity:1;color:#fff;color:rgba(255,255,255,var(--text-opacity));border-radius:.375rem}", ""]);

// exports
